export enum WebVitals {
  Hydration = 'hydration',
  TTFB = 'TTFB',
  FCP = 'FCP',
  LCP = 'LCP',
  FID = 'FID',
  CLS = 'CLS',
  INP = 'INP',
}

export enum ClientMetricsActions {
  Show = 'shows',
  Click = 'clicks',
  Attempt = 'attempts',
  Success = 'successes',
  Failure = 'failures',
  Input = 'input',
  Submit = 'submit',
}

export enum GeneralClientMetrics {
  ExtensionNotch = 'extensionNotch',
  BoundaryError = 'boundaryError',
  Signin = 'signin',
  Signup = 'signup',
  Page = 'page',
  WebVitals = 'webVitals',
  Iframe = 'iframe',
}
